module.exports = __webpack_public_path__ + "static/img/bg_tpyx.3fadb6a6.png";